"use strict";
/**
 * Main entry point
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const abTesting_store_1 = __importDefault(require("./stores/abTesting.store"));
const accountPage_store_1 = __importDefault(require("./stores/account/accountPage.store"));
/**  start-no-seo */
const bookingExtension_store_1 = __importDefault(require("./stores/booking/bookingExtension.store"));
const bookingPage_store_1 = __importDefault(require("./stores/booking/bookingPage.store"));
/** end-no-seo */
const branch_store_1 = __importDefault(require("./stores/branch.store"));
/**  start-no-seo */
const branchAvailability_store_1 = __importDefault(require("./stores/branchAvailability.store"));
/** end-no-seo */
/**  start-no-seo */
const city_store_1 = __importDefault(require("./stores/city.store"));
/** end-no-seo */
const cmsPage_store_1 = __importDefault(require("./stores/cms/cmsPage.store"));
const config_store_1 = __importDefault(require("./stores/config.store"));
/**  start-no-seo */
const cdpDomain_store_1 = __importDefault(require("./stores/corporate/cdpDomain.store"));
const generateCDPOTP_store_1 = __importDefault(require("./stores/corporate/generateCDPOTP.store"));
const verifyCDPOTP_store_1 = __importDefault(require("./stores/corporate/verifyCDPOTP.store"));
/** end-no-seo */
const corporatePartnerList_store_1 = __importDefault(require("./stores/corporatePartnerList.store"));
const country_store_1 = __importDefault(require("./stores/country.store"));
const experienceFeedback_store_1 = __importDefault(require("./stores/experienceFeedback.store"));
/** end-no-seo */
const fleetDetailsPage_store_1 = __importDefault(require("./stores/fleetDetailsPage.store"));
const fleetPage_store_1 = __importDefault(require("./stores/fleetPage.store"));
/**  start-no-seo */
const fleetQuote_store_1 = __importDefault(require("./stores/fleetQuote.store"));
const fleetQuoteDetails_store_1 = __importDefault(require("./stores/fleetQuoteDetails.store"));
/** end-no-seo */
const location_store_1 = __importDefault(require("./stores/location.store"));
const promoList_store_1 = __importDefault(require("./stores/promoList.store"));
const quickPayPage_store_1 = __importDefault(require("./stores/quickPay/quickPayPage.store"));
/**  start-no-seo */
const quoteExpiry_store_1 = __importDefault(require("./stores/quoteExpiry.store"));
const rentalPolicies_store_1 = __importDefault(require("./stores/rentalPolicies.store"));
const rewards_store_1 = __importDefault(require("./stores/rewards.store"));
/** end-no-seo */
const searchPage_store_1 = __importDefault(require("./stores/searchPage.store"));
/**  start-no-seo */
const searchSessionExpiry_store_1 = __importDefault(require("./stores/searchSessionExpiry.store"));
class AppStore {
    /**  end-no-seo */
    constructor(initialState = {}) {
        this.config = new config_store_1.default(initialState.config);
        this.abTesting = new abTesting_store_1.default(initialState.abTesting);
        const $env = { config: this.config };
        this.branch = new branch_store_1.default(initialState.branch, $env);
        this.fleetPage = new fleetPage_store_1.default(initialState.fleetPage, $env);
        this.searchPage = new searchPage_store_1.default(initialState.searchPage, $env);
        this.fleetDetailsPage = new fleetDetailsPage_store_1.default(initialState.fleetDetailsPage, $env);
        /**  start-no-seo */
        this.city = new city_store_1.default(initialState.city, $env);
        this.branchAvailability = new branchAvailability_store_1.default($env);
        this.bookingExtension = new bookingExtension_store_1.default($env);
        this.fleetQuote = new fleetQuote_store_1.default(initialState.fleetQuote);
        this.fleetQuoteDetails = new fleetQuoteDetails_store_1.default(initialState.fleetQuoteDetails, $env);
        this.searchExpiry = new searchSessionExpiry_store_1.default(initialState.searchExpiry);
        this.quoteExpiry = new quoteExpiry_store_1.default(initialState.quoteExpiry);
        this.bookingPage = new bookingPage_store_1.default(initialState.bookingPage, $env);
        this.rewardsStore = new rewards_store_1.default(initialState.rewards, $env);
        this.rentalPolicies = new rentalPolicies_store_1.default(initialState.rentalPolicies, $env);
        this.experienceFeedbackStore = new experienceFeedback_store_1.default(initialState.experienceFeedbackQuestions, $env);
        /**  end-no-seo */
        this.country = new country_store_1.default(initialState.country, $env);
        this.location = new location_store_1.default(initialState.location);
        this.accountPage = new accountPage_store_1.default(initialState.accountPage, $env);
        this.cms = new cmsPage_store_1.default(initialState.cms, $env);
        this.promoList = new promoList_store_1.default(initialState.promoList, $env);
        /**  start-no-seo */
        this.quickPayPage = new quickPayPage_store_1.default(initialState.quickPayPage, $env);
        this.corporatePartnerList = new corporatePartnerList_store_1.default(initialState.corporatePartnerList, $env);
        this.cdpDomain = new cdpDomain_store_1.default(initialState.cdpDomain);
        this.generateCDPOTP = new generateCDPOTP_store_1.default(initialState.generateCDPOTP);
        this.verifyCDPOTP = new verifyCDPOTP_store_1.default(initialState.verifyCDPOTP);
        /**  end-no-seo */
    }
}
exports.default = AppStore;
